export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7532.9c937b27.jpg";